const globImages: GlobImageI = import.meta.glob('~/assets/images/pages/news/*', {
  eager: true
})
const iconImgUrl = '/assets/images/pages/news'

export const SLUG_CATEGORY_NEWS = {
  ALL: 'tat-ca',
  LO_DE_ONLINE: 'lo-de-online',
  SOI_KEO: 'soi-keo-bong-da',
  TIP_FOOTBALL: 'tip-bong-da',
  BETTING_EXPERIENCE: 'kinh-nghiem-ca-cuoc',
  BASKETBALL: 'keo-bong-ro',
  JACKPOT: 'no-hu',
  HIGH_LIGHT: 'tin-noi-bat'
}

export const listCategory = [
  {
    name: 'LÔ ĐỀ ONLINE',
    slug: SLUG_CATEGORY_NEWS.LO_DE_ONLINE,
    subCategory: ['62']
  },
  {
    name: 'Soi kèo bóng đá',
    slug: SLUG_CATEGORY_NEWS.SOI_KEO,
    subCategory: ['67']
  },
  {
    name: 'TIP BÓNG ĐÁ',
    slug: SLUG_CATEGORY_NEWS.TIP_FOOTBALL,
    subCategory: ['52']
  },
  {
    name: 'KINH NGHIỆM CÁ CƯỢC',
    slug: SLUG_CATEGORY_NEWS.BETTING_EXPERIENCE,
    subCategory: ['946']
  },
  {
    name: 'KÈO BÓNG RỔ',
    slug: SLUG_CATEGORY_NEWS.BASKETBALL,
    subCategory: ['3']
  },
  {
    name: 'Nổ hũ',
    slug: SLUG_CATEGORY_NEWS.JACKPOT,
    subCategory: ['17']
  },
  {
    name: 'Xóc đĩa',
    slug: 'xoc-dia',
    subCategory: ['16']
  },
  {
    name: 'Game Bắn Cá',
    slug: 'game-ban-ca',
    subCategory: ['15']
  },
  {
    name: 'Tin Nổi Bật',
    slug: SLUG_CATEGORY_NEWS.HIGH_LIGHT,
    subCategory: ['898']
  },
  {
    name: 'Tất Cả',
    slug: SLUG_CATEGORY_NEWS.ALL,
    subCategory: ['69,67,62,52']
  }
]

export const sideBarCategories = [
  {
    title: 'Tất cả',
    subTitle: 'Tin Trong Tuần',
    icon: getImageURL(globImages, 'tat-ca-news', iconImgUrl, 'svg'),
    slug: SLUG_CATEGORY_NEWS.ALL
  },
  {
    title: 'Lô đề Online',
    subTitle: 'Lô đề Online',
    icon: getImageURL(globImages, 'lo-de-news', iconImgUrl, 'svg'),
    slug: SLUG_CATEGORY_NEWS.LO_DE_ONLINE
  },
  {
    title: 'Soi kèo bóng đá',
    subTitle: 'Soi kèo bóng đá',
    icon: getImageURL(globImages, 'soi-keo-bong-da-news', iconImgUrl, 'svg'),
    slug: SLUG_CATEGORY_NEWS.SOI_KEO
  },
  {
    title: 'Tip bóng đá',
    subTitle: 'Tip bóng đá',
    icon: getImageURL(globImages, 'tip-bong-da-news', iconImgUrl, 'svg'),
    slug: SLUG_CATEGORY_NEWS.TIP_FOOTBALL
  },
  {
    title: 'Kinh nghiệm cá cược',
    subTitle: 'Kinh nghiệm cá cược',
    icon: getImageURL(globImages, 'kinh-nghiem-ca-cuoc-news', iconImgUrl, 'svg'),
    slug: SLUG_CATEGORY_NEWS.BETTING_EXPERIENCE
  },
]
